export function sanitizeDefaults(properties: Record<string, any>): void {
  for (const property of Object.values(properties)) {
    if (property.default !== undefined) {
      // If has enum, infer type from first enum value and convert default
      if (Array.isArray(property.enum) && property.enum.length > 0) {
        property.default = sanitizeAndParseValue(property.default, typeof property.enum[0]);
      } else if (property.type) {
        property.default = sanitizeAndParseValue(property.default, property.type);
      }
    }
  }
}

function sanitizeAndParseValue(value: any, expectedType: string): string | number | boolean | null {
  if (value === null || value === undefined || value === '') {
    return value;
  }

  // If type already matches, return as-is
  if (typeof value === expectedType) {
    return value;
  }

  // Convert to expected type
  switch (expectedType) {
    case 'number': {
      const num = Number(value);
      return !Number.isNaN(num) && Number.isFinite(num) ? num : value;
    }

    case 'boolean':
      if (typeof value === 'string') {
        const lower = value.toLowerCase().trim();
        if (lower === 'true') return true;
        if (lower === 'false') return false;
      }
      return Boolean(value);

    case 'string':
      return String(value);

    default:
      return value;
  }
}
